import {api} from '../../utils/api'

export default {

    /**
     * load Instances
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadInstances({commit}, taskID) {
        return api.call(commit, 'get', '/api/instance/'+taskID, null,  'SET_INSTANCES');
    },

    /**
     * Update Instances
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    updateInstance({commit}, payload) {
        return api.call(commit, 'patch', '/api/instance/' + payload.id,
            {
                task_id: api.clearInstance(payload.task_id),
                task_instance_id: api.clearTask(payload.task_id)
            }, 'SET_INSTANCES');
    },

    /**
     * Delete Instances
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    deleteInstance({commit}, payload) {
        return api.call(commit, 'delete', '/api/instance/' + payload.id, null, 'DELETE_INSTANCES');
    },

    /**
     * create new Instance
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    createInstance({commit}, payload) {
        // Create new field
        return api.call(commit, 'post', '/api/instance/'+payload.parent_id, payload, 'SET_INSTANCES');
    },


}
